export const SUPPLIERS_BY_TAG: Record<string, string> = {
  IJP: 'playson',
  OPJ: 'octoplay',
}
